<a mat-button [matMenuTriggerFor]="langMenu" #langMenuTrigger="matMenuTrigger">
  <img [src]="flag.image" width="18">
  <span class="show-gt-md hide-lt-md uppercase flag-name">{{flag.name}}</span>
  <mat-icon class="mat-icon-sm caret">arrow_drop_down</mat-icon>
</a>
<mat-menu #langMenu="matMenu" [overlapTrigger]="false" xPosition="before" class="app-menu-panel">
  <span (mouseleave)="langMenuTrigger.closeMenu()">
    @for (flag of flags; track flag) {
      <button mat-menu-item (click)="changeLang(flag)">
        <img [src]="flag.image" width="18" class="mat-elevation-z1"><span class="flag-name">{{flag.name}}</span>
      </button>
    }
  </span>
</mat-menu>